import { type Components } from '@mui/material';

import { type HorizonTheme } from './horizon-theme';

export const muiDateCalendar: Components<HorizonTheme>['MuiDateCalendar'] = {
  styleOverrides: {
    root: {
      borderRadius: 4,
      border: '1px solid #B1B8BF',
      boxShadow: '0 2px 8px 0 rgba(78, 80, 84, 0.16)',
    },
  },
};
